export default __webpack_public_path__ + "static/media/Investment.b9990b25.jpg";